type ENV = {
  loc: string
  test: string
  gray: string
  prod: string
}

const BASEURL_MAP = {
  loc: 'https://mlmapi.yingsaidata.tech', //本地开发
  test: 'https://mlmapi.yingsaidata.tech', // 测试环境
  gray: '//gray.mipapi.yingsaidata.com', // 灰度环境
  prod: '//mlmapi.yingsaidata.com' // 正式环境
}

const OSSURL_MAP = {
  loc: '//test.ossapi.yingsaidata.tech', //本地开发
  test: '//test.ossapi.yingsaidata.tech', // 测试环境
  gray: '//gray.ossapi.yingsaidata.tech', // 灰度环境
  prod: '//ossapi.yingsaidata.tech' // 正式环境
}

const UPLOADURL_MAP = {
  loc: '//test.mipapi.yingsaidata.com', //本地开发
  test: '//test2.mipapi.yingsaidata.com', // 测试环境
  gray: '//gray.mipapi.yingsaidata.com', // 灰度环境
  prod: '//mipapi.yingsaidata.com' // 正式环境
}

// const STREAM_URL_MAP = {
//   loc: '//test.llmsteam.yingsaidata.tech/llm/chat/messageStream', //本地开发
//   test: '//test.llmsteam.yingsaidata.tech/llm/chat/messageStream', // 测试环境
//   gray: '//llmsteam.yingsaidata.com/llm/chat/messageStream', // 灰度环境
//   prod: '//llmsteam.yingsaidata.com/llm/chat/messageStream' // 正式环境
// }

const STREAM_URL_MAP = {
  loc: `${BASEURL_MAP.loc}/llm/chat/conversation`, //本地开发
  test: `${BASEURL_MAP.test}/llm/chat/conversation`, // 测试环境
  gray: `${BASEURL_MAP.gray}/llm/chat/conversation`, // 灰度环境
  prod: `${BASEURL_MAP.prod}/llm/chat/conversation` // 正式环境
}
// export const messageStreamUrl = `https://llmsteam.yingsaidata.com/llm/chat/messageStream`
export const VERSION = 'v1.0.0'

export default {
  baseUrl(): string {
    const env = import.meta.env.VITE_APP_ENV as keyof ENV
    // const env = 'prod'
    console.log('uploadUrl', import.meta.env)

    return BASEURL_MAP[env] || BASEURL_MAP['loc']
  },
  ossUrl(): string {
    const env = import.meta.env.VITE_APP_ENV as keyof ENV
    // const env = 'prod'

    return OSSURL_MAP[env] || OSSURL_MAP['loc']
  },
  uploadUrl(): string {
    const env = import.meta.env.VITE_APP_ENV as keyof ENV
    // const env = 'prod'

    console.log('uploadUrl', import.meta.env.VITE_APP_ENV)

    return UPLOADURL_MAP[env] || UPLOADURL_MAP['loc']
  },
  messageStreamUrl(): string {
    const env = import.meta.env.VITE_APP_ENV as keyof ENV
    // const env = 'prod'

    console.log('messageStreamUrl', import.meta.env.VITE_APP_ENV)

    return STREAM_URL_MAP[env] || STREAM_URL_MAP['loc']
  }
}

//平台代号枚举
export enum PlatformCode {
  'littleRedBook' = 1027,
  'tiktok' = 1012,
  'weChat' = 1014,
  'microBlog' = 1013,
  'bilibili' = 1022,
  'zhihu' = 1008
}

export enum PlatformNameEnum {
  '微博' = 1013,
  '微信' = 1014,
  '抖音' = 1012,
  '小红书' = 1027,
  'B站' = 1022,
  '知乎' = 1008
}

export enum PlatformLogoEnum {
  'https://static5.yingsaidata.com/media/siteset/xiaohongshu.png' = PlatformCode.littleRedBook,
  'https://static5.yingsaidata.com/media/siteset/douyin.png' = PlatformCode.tiktok,
  'https://static5.yingsaidata.com/media/siteset/wechat.png' = PlatformCode.weChat,
  'https://static5.yingsaidata.com/media/siteset/sina_weibo.png' = PlatformCode.microBlog,
  'https://static5.yingsaidata.com/media/siteset/bilibili.png' = PlatformCode.bilibili,
  'https://static5.yingsaidata.com/media/siteset/zhihu2.png' = PlatformCode.zhihu
}
